import React from 'react';

export function CollapsibleSection({
  id,
  title,
  summary = '',
  badgeCount = 0,
  badgeLabel = '',
  open,
  onToggle,
  children,
  sectionRef = null,
}) {
  if (!children) return null;

  const panelId = `event-readonly-section-${id}`;

  return (
    <section className="event-readonly-section" ref={sectionRef}>
      <button
        type="button"
        className="event-readonly-section__toggle"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span className="event-readonly-section__title">{title}</span>
        {badgeCount > 0 ? (
          <span className="event-readonly-section__badge" aria-label={badgeLabel || `${badgeCount} items`}>
            {badgeCount}
          </span>
        ) : null}
        {summary ? (
          <span className="event-readonly-section__summary">{summary}</span>
        ) : null}
        <span className="event-readonly-section__chevron" aria-hidden="true">
          {open ? '▾' : '▸'}
        </span>
      </button>
      {open ? (
        <div id={panelId} className="event-readonly-section__body">
          {children}
        </div>
      ) : null}
    </section>
  );
}

export function EventSectionsSkeleton() {
  return (
    <div className="event-readonly-loading" aria-label="Loading event details" aria-busy="true">
      {[0, 1, 2].map((index) => (
        <div key={index} className="event-readonly-loading__section">
          <div className="event-readonly-loading__line event-readonly-loading__line--title" />
          <div className="event-readonly-loading__line event-readonly-loading__line--meta" />
        </div>
      ))}
    </div>
  );
}
